

























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { getCost } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import FormatMoney from "@/components/FormatMoney";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import UserSubscribeModal from "@/components/UserSubscribeModal";

@Component({
  name: "UnlockFeedView",
  components: { UserSubscribeModal, PageTitle, BaseButton, ModalView, BaseConfirm, FormatMoney },
})
export default class UnlockFeedView extends Vue {
  @Prop({ required: true })
  public selectedFeed!: ContentFeed;

  @Prop({ type: Array, required: true })
  public readonly paymentPackages!: PaymentPackage[];

  @Prop({ type: Boolean, required: true })
  public readonly purchaseProcessing!: boolean;

  public get isOnlyPrice() {
    return this.selectedFeed.subscriptionLevelId === "0" && this.selectedFeed.pricePackageId !== "0";
  }

  public get oneTimeCost() {
    if (this.selectedFeed.pricePackageId === "0") return 0;
    const paymentPackage = this.paymentPackages.find(item => item.id === this.selectedFeed.pricePackageId);
    if (!paymentPackage) return 0;
    return getCost(paymentPackage);
  }
}
